import { gql } from '@apollo/client';

export const GET_UNREAD_MESSAGES_COUNT = gql`
  query GetUnreadMessagesCount($user_id: ID!) {
    getUserUnReadMessageCount(user_id: $user_id)
  }
`;